import styles from './MyOCLogin2018.module.css';
import { type AuthBanner } from './types';

interface BannerProps {
  banner: AuthBanner;
  resendLabel: string;
}

/**
 * Message banner shown above the auth form (ported from the legacy `banner` component). The container
 * resolves the localised title/message; this component only renders. The `verification` variant adds a
 * link button that re-triggers the verification email.
 */
const Banner: React.FC<BannerProps> = ({ banner, resendLabel }) => {
  const variantClass = banner.type === 'success' ? styles.bannerSuccess : styles.bannerError;

  return (
    <div className={`${styles.banner} ${variantClass}`} data-testid="myoc-auth-banner">
      <div className={styles.bannerTitle}>{banner.title}</div>
      <div className={styles.bannerMessage}>
        {banner.message}
        {banner.type === 'verification' && (
          <button className={styles.linkButton} onClick={banner.onResend} type="button">
            {resendLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default Banner;
